import { useGlobalAlert as globalAlert } from "hooks/useAlert";
import { ActionFunctionArgs } from "react-router-dom";
import { api } from "services/api.service";
import { isAxiosError } from "utils/helpers";

export async function action({ request, params }: ActionFunctionArgs) {
  const formData = await request.formData();

  try {
    const response = await api.request({
      method: "PUT",
      url: `/asset_retrievals/${params.retrievalId}/force_completed`,
      data: formData,
    });

    if (response.status === 200) globalAlert.alertSuccess("Asset retrieval order marked as completed.");
    return null;
  } catch (error: unknown) {
    if (isAxiosError(error))
      globalAlert.alertError(`Could not mark order as completed. ${error.response?.data.message}`);
    return null;
  }
}
